import { FEATURE_PERMISSIONS } from "@/core/types/permissions";
import useSubscriptionPermissionsChecker from "@/hooks/useSubscriptionPermissionsChecker";
import { UseSubsPermissionsActionTypes } from "@/types/hooks";
import { CopyUrlDialogModalWindow } from "@/components/modules/Post/CopyUrlDialogModalWindow";
import { DialogModalWindow } from "@/components/modules/Post/DialogModalWindow";
import { useAuthUrls } from "@/hooks/useAuthUrls";
import { BaseButton } from "@/components/ui-kit/Buttons/BaseButton";
import { ButtonType } from "@/types/ui-kit/buttons";

type PostPaywallUnlockAttemptModalProps = {
  isDialogVisible: boolean;
  setIsDialogVisible: React.Dispatch<React.SetStateAction<boolean>>;
};

const PostPaywallUnlockAttemptModal: React.FC<PostPaywallUnlockAttemptModalProps> = ({
  isDialogVisible,
  setIsDialogVisible,
}) => {
  const { getSubscriptionUrl } = useAuthUrls();
  const isFeaturePermission = useSubscriptionPermissionsChecker(
    UseSubsPermissionsActionTypes.INVALID_PERMISSIONS,
    FEATURE_PERMISSIONS.SHARE
  );

  return (
    <>
      {isFeaturePermission ? (
        <DialogModalWindow
          title="Pro odemykání článků je třeba mít aktivované předplatné"
          button={<BaseButton href={getSubscriptionUrl()} title="Chci předplatné" type={ButtonType.Primary} />}
          isOpen={isDialogVisible}
          onClose={() => setIsDialogVisible(false)}
        />
      ) : (
        <CopyUrlDialogModalWindow isOpen={isDialogVisible} onClose={() => setIsDialogVisible(false)} />
      )}
    </>
  );
};

export default PostPaywallUnlockAttemptModal;
